import React, { useContext, useState } from "react";
import { Button } from "../../form";
import { TableJavaComponent } from "../../base/TableJavaComponent";
import { APIContext } from "../../../contexts/APIContext";
import { ModalInfluencerComponent } from "../../base/ModalInfluencerComponent";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormComponent } from "../../dynamic/form";
import { formRebateProgramCatalog } from "../../../forms";
import { useTranslation } from "react-i18next";
import SearchBoxUsers from "../../base/SearchBoxUsers";

export default function RebateProgramCatalog() {
    const { t } = useTranslation();;
    const { getAllInfluencers, updateInfluencer, createInfluencer, deleteInfluencer, uploadFile } = useContext(APIContext);
    const [influencers, setInfluencers] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [file, setFile] = useState(null);
    const [typeFile, setTypeFile] = useState(null);
    const landingURL = process.env.REACT_APP_LANDING_INFLUENCER

    const convertToISO8601 = (dateString) => {
        const date = new Date(dateString + "T00:00:00Z");
        return date.toISOString();
    };

    const isImageOrVideo = (fileName) => {
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
        const videoExtensions = ["mp4", "avi", "mov", "mkv", "webm", "flv", "wmv"];

        const fileExtension = fileName.split(".").pop().toLowerCase();

        if (imageExtensions.includes(fileExtension)) {
            return "IMG";
        } else if (videoExtensions.includes(fileExtension)) {
            return "VIDEO";
        } else {
            return null;
        }
    };

    const convertToDateInputFormat = (isoString) => {
        const date = new Date(isoString);
        date.setUTCHours(0, 0, 0, 0);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const uploadFileS3 = async (file) => {
        const bucketName = process.env.REACT_APP_AWS_NAME;
        const region = process.env.REACT_APP_AWS_REGION;
        const filePath = `influencers/${Date.now()}_${file.name}`;

        try {
            const response = await uploadFile({ bucketName, region, filePath, file });
            if(response.status !== 200) throw new Error('Error al subir imagen');
          return  process.env.REACT_APP_IMAGE_INFLUENCER + filePath;
        } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    };

    const handleSubmitFilter = (criteria) => {
        const queryParams = Object.entries(criteria)
            .filter(([key, value]) => value)
            .map(([key, value]) => `${key}=${value}`)
            .join("&");

        getData(0, queryParams);
    };

    const getData = (page, queryParams) => {
        setLoading(true);
        queryParams = queryParams != null ? `&${queryParams}` : '';
        getAllInfluencers(page, queryParams)
          .then((data) => {
              const processedData = data.influencers.content.map((influencer) => ({
                  ...influencer,
                  surgeryStartDate: convertToDateInputFormat(influencer.surgeryStartDate),
                  surgeryEndDate: convertToDateInputFormat(influencer.surgeryEndDate),
                  programEndDate: convertToDateInputFormat(influencer.programEndDate)
              }));

              data.influencers.content = processedData;

              setInfluencers(data.influencers);
          })
          .finally(() => setLoading(false));
    };

    const newItem = () => {
        setTypeFile("");
        setFile("");
        setOpenModal(true);
    };

    const editItem = (row) => {
        setOpenModal(true);
        formik.setValues({
            id: row.id,
            hash: row.hash,
            codePrefix: row.codePrefix,
            firstName: row.firstName,
            lastName: row.lastName,
            surgeryStartDate: row.surgeryStartDate,
            surgeryEndDate: row.surgeryEndDate,
            programEndDate: row.programEndDate,
            instagram: row.instagram,
            tiktok: row.tiktok,
            termsAndConditionsUrl: row.termsAndConditionsUrl,
            note: row.note,
            active: row.active,
            documentTypeValue: row.documentType === "YT" ? 0 : 1,
            youtubeVideo: row.documentType === "YT" ? row.documentUri : ""
        });

        if (row.documentUri) {
            setTypeFile(row.documentType);
            setFile(row.documentUri);
        }
    };

    const deleteItem = async (id) => {
        let payload = {
            id: id
        }
        await deleteInfluencer(payload.id).then((data) => {
            setInfluencers([]);
            getData(0);
            closeModal();
        }).catch((e) => {
            setErrorMessage("An error occurred while deleting the influencer");

            setTimeout(()=> {
                setErrorMessage(null);
            }, 4000)
        });
    }

    const closeModal = () => {
        setOpenModal(false);
        formik.resetForm();
    };

    const handlePreSubmit = async (values) => {

        const documentUriElement = document.getElementsByName("documentUri")[0];
        const youtubeVideoElement = document.getElementsByName("youtubeVideo")[0];

        if (documentUriElement && documentUriElement.files.length > 0 && values.documentTypeValue == 1) {
            try {
                const uploadedFileName = await uploadFileS3(documentUriElement.files[0]);
                values.documentUri = uploadedFileName;
                values.documentType = isImageOrVideo(uploadedFileName);
            } catch (error) {
                values.documentUri = null;
                values.documentType = null;
                return;
            }
        } else if (values.documentTypeValue == 0) {
            if (youtubeVideoElement) {
                values.documentUri = youtubeVideoElement.value;
                values.documentType = "yt";
            } else {
                values.documentUri = null;
                values.documentType = null;
            }
        } else {
            values.documentUri = file || null;
            values.documentType = typeFile || null;
        }

    };

    const Schema = Yup.object({
        codePrefix: Yup.string().required("Influencer Code is required field"),
        firstName: Yup.string().required("Influencer First name is required field"),
        lastName: Yup.string().required("Influencer Last Name is a required field"),
        termsAndConditionsUrl: Yup.string().required("Terms And Conditions is a required field"),
        surgeryStartDate: Yup.date().required("Surgery Start Date is required field"),
        surgeryEndDate: Yup.date().required("Surgery End Date is required field"),
        programEndDate: Yup.date().required("Program End Date is required field"),
    });

    const formik = useFormik({
        initialValues: {
            id: "",
            codePrefix: "",
            firstName: "",
            lastName: "",
            surgeryStartDate: "",
            surgeryEndDate: "",
            programEndDate: "",
            documentUri: null,
            documentType: null,
            instagram: "",
            tiktok: "",
            termsAndConditionsUrl: "",
            note: "",
            active: 1,
            hash: "",
            documentTypeValue: 1,
            youtubeVideo: ""
        },
        validationSchema: Schema,
        onSubmit: async (values) => {
            const payload = {
                ...values,
            };

            payload.codePrefix = payload.codePrefix ? values.codePrefix.trim() : payload.codePrefix;
            payload.firstName = payload.firstName ? values.firstName.trim() : payload.firstName;
            payload.lastName = payload.lastName ? values.lastName.trim() : payload.lastName;
            payload.instagram = payload.instagram ? values.instagram.trim() : payload.instagram;
            payload.tiktok = payload.tiktok ? values.tiktok.trim() : payload.tiktok;
            payload.note = payload.note ? values.note.trim() : payload.note;
            payload.termsAndConditionsUrl = payload.termsAndConditionsUrl ? values.termsAndConditionsUrl.trim() : payload.termsAndConditionsUrl;

            await handlePreSubmit(payload);

            // Remove unknown JSON properties to send valid request, without it the API will throw an error because
            // Jackson is using strict deserialization
            delete payload.documentTypeValue;
            delete payload.youtubeVideo;

            const apiCall = values.id ? updateInfluencer : createInfluencer;
            payload.surgeryStartDate = convertToISO8601(payload.surgeryStartDate);
            payload.surgeryEndDate = convertToISO8601(payload.surgeryEndDate);
            payload.programEndDate = convertToISO8601(payload.programEndDate);

            apiCall(payload)
                .then(() => {
                    setInfluencers([]);
                    getData(0);
                    closeModal();
                })
                .catch(console.error);
        },
    });

    const actions = {
        close: closeModal,
        delete: deleteItem
    }

    return (
        <>
            <Button onClick={() => newItem()} primary>{t("general.new")}</Button>
            <SearchBoxUsers onSearch={handleSubmitFilter} availableCriterias={[
                {key: "codePrefix", label: "Search By Influencer Code"},
                {key: "firstName", label: "Search By Name"},
                {key: "lastName", label: "Search By Last Name"},
            ]} />
            {influencers && (
                <TableJavaComponent
                    rows={influencers}
                    columns={[
                        { label: "Landing URL", link: landingURL , keyValue: "hash", name: "Site"},
                        { label: "Influencer Code", keyValue: "codePrefix" },
                        { label: "Influencer First Name", keyValue: "firstName" },
                        { label: "Influencer Last Name", keyValue: "lastName" },
                        { label: "Surgery Start Date", keyValue: "surgeryStartDate" },
                        { label: "Surgery End Date", keyValue: "surgeryEndDate" },
                        { label: "Program End Date", keyValue: "programEndDate" },
                        { label: "Instagram", keyValue: "instagram" },
                        { label: "Tiktok", keyValue: "tiktok" },
                        { label: "Terms and Conditions", keyValue: "termsAndConditionsUrl" },
                        { label: "Quote", keyValue: "note" },
                        { label: "Active", keyValue: "active" },
                    ]}
                    editRow={editItem}
                    fetchData={getData}
                    autoLoad
                    isLoading={loading}
                />
            )}
            {openModal && (
                <ModalInfluencerComponent
                    open={openModal}
                    close={closeModal}
                    errorMessage={errorMessage}
                    title={ formik.values.id === "" ? t("settings.influencer.new") : t("settings.influencer.edit") }
                    content={
                        <FormComponent formFields={[ ...formRebateProgramCatalog(t, formik),]}
                            formik={formik}
                                       action={actions}
                        />
                    }
                    media={ file ? { type: typeFile, src: file} : null }
                />
            )}
        </>
    );
}